var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5446_111659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66669 2.66666C5.66669 2.66666 5.98276 4.22537 6.54537 4.78798C7.10798 5.35059 8.66669 5.66666 8.66669 5.66666C8.66669 5.66666 7.10798 5.98273 6.54537 6.54534C5.98276 7.10795 5.66669 8.66666 5.66669 8.66666C5.66669 8.66666 5.35062 7.10795 4.78801 6.54534C4.2254 5.98273 2.66669 5.66666 2.66669 5.66666C2.66669 5.66666 4.2254 5.35059 4.78801 4.78798C5.35062 4.22537 5.66669 2.66666 5.66669 2.66666Z",
    fill: "#3E2079",
    stroke: "#3E2079",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.66666C11 8.66666 11.2459 9.87899 11.6834 10.3166C12.121 10.7542 13.3334 11 13.3334 11C13.3334 11 12.121 11.2458 11.6834 11.6834C11.2459 12.121 11 13.3333 11 13.3333C11 13.3333 10.7542 12.121 10.3166 11.6834C9.87902 11.2458 8.66669 11 8.66669 11C8.66669 11 9.87902 10.7542 10.3166 10.3166C10.7542 9.87899 11 8.66666 11 8.66666Z",
    fill: "#3E2079",
    stroke: "#3E2079",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5446_111659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.73e2c73110b63084ddb96a4efee05447.svg";
export { ForwardRef as ReactComponent };